import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinpune() {



    const cardData =
    {
        keyword: 'Bus On Rent In Pune',
        heading: 'Urbania on rent in pune: Bus On Rent In Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and dependable Bus On Rent in Pune services for corporate groups, families, tourists, and event travelers seeking comfortable and spacious group transportation across Pune and nearby destinations. Our well‑maintained Force Urbania bus fleet provides generous seating, air‑conditioned comfort, luggage space, and smooth performance, making it ideal for airport transfers, local tours, corporate outings, weddings, sightseeing trips, and outstation journeys. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for bus hire in Pune.',

        top: 'Top Places to Visit in Pune with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha pride. Known for its massive stone walls, grand gateways like Delhi Darwaza, and lush gardens, it once served as the seat of Bajirao I’s administration. Though largely destroyed by fire, its remnants echo royal grandeur. The evening light-and-sound show brings Maratha history to life, making it a must-visit for history enthusiasts."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum displaying Gandhi’s personal artifacts and photographs. Its sprawling gardens, Italian arches, and samadhis of Kasturba and Mahadev Desai make it a serene retreat and a symbol of patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The temple trust is known for its charitable activities. Devotees find immense peace and blessings here, making it the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to explore ancient ramparts, memorials, and scenic viewpoints. Local vendors serve traditional pithla-bhakri meals near the summit. The fort offers panoramic views of the Sahyadri ranges, blending history, adventure, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings are a testament to early Indian craftsmanship, making it Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a major attraction, making the museum Pune’s living archive of art and craftsmanship."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing, making Parvati Hill a spiritual and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and transformation, making it Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, making it Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during monsoon. Street vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends and sunsets."
  }
],




"services": [
{
"name": "Bus on Rent Pune",
"description": "Bus on Rent Pune offers reliable and comfortable bus rental services for local and long-distance travel. Perfect for families, groups, and corporate travelers, it ensures spacious seating, clean interiors, and professional drivers for a smooth journey."
},
{
"name": "Bus Hire Pune",
"description": "Bus Hire Pune provides flexible rental options for AC and non-AC buses, catering to one-way, round-trip, and multi-day travel plans with punctual service and well-maintained vehicles."
},
{
"name": "AC Bus Rental Pune",
"description": "AC Bus Rental Pune offers fully air-conditioned buses for comfortable and climate-controlled travel, ideal for long journeys, corporate trips, and family tours."
},
{
"name": "Non AC Bus Hire Pune",
"description": "Non AC Bus Hire Pune provides budget-friendly travel options with safe and clean buses, perfect for group outings, picnics, and local transport."
},
{
"name": "Corporate Bus Hire Pune",
"description": "Corporate Bus Hire Pune delivers organized transportation solutions for corporate teams, business tours, and official events, emphasizing punctuality, comfort, and professional drivers."
},
{
"name": "Bus for Wedding Pune",
"description": "Bus for Wedding Pune offers well-decorated and comfortable buses for wedding events, ensuring safe and stylish transport for guests."
},
{
"name": "Bus for Outstation Pune",
"description": "Bus for Outstation Pune provides reliable and spacious buses for long-distance and interstate travel, focusing on safety, comfort, and timely arrivals."
},
{
"name": "Bus Airport Transfer Pune",
"description": "Bus Airport Transfer Pune offers convenient and timely pick-up and drop services to and from Pune airport with professional chauffeurs and comfortable buses."
},
{
"name": "Luxury Bus Hire Pune",
"description": "Luxury Bus Hire Pune delivers premium buses with plush seating, modern interiors, and excellent ride comfort, perfect for VIP travel and special events."
},
{
"name": "Affordable Bus Rental Pune",
"description": "Affordable Bus Rental Pune provides cost-effective options without compromising on safety or comfort, suitable for groups and budget-conscious travelers."
},
{
"name": "Chauffeur Driven Bus Pune",
"description": "Chauffeur Driven Bus Pune ensures a stress-free journey with trained, verified drivers familiar with local and long-distance routes."
},
{
"name": "Bus for Group Travel Pune",
"description": "Bus for Group Travel Pune offers spacious and coordinated transportation for large groups, ensuring everyone travels together safely and comfortably."
},
{
"name": "Best Bus Rental Pune",
"description": "Best Bus Rental Pune is known for reliable vehicles, professional service, and consistent performance, making it a preferred choice for all kinds of travel."
},
{
"name": "Bus for Picnic Pune",
"description": "Bus for Picnic Pune provides comfortable and safe transport for family outings, school trips, and recreational activities with timely service."
},
{
"name": "Reliable Bus Service Pune",
"description": "Reliable Bus Service Pune offers dependable bus rentals with focus on punctuality, comfort, safety, and excellent customer support."
}
],
"tableData": [
["Bus on Rent Pune", "Bus Hire Pune"],
["AC Bus Rental Pune", "Non AC Bus Hire Pune"],
["Corporate Bus Hire Pune", "Bus for Wedding Pune"],
["Bus for Outstation Pune", "Bus Airport Transfer Pune"],
["Luxury Bus Hire Pune", "Affordable Bus Rental Pune"],
["Chauffeur Driven Bus Pune", "Bus for Group Travel Pune"],
["Best Bus Rental Pune", "Bus for Picnic Pune"],
["Reliable Bus Service Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Bus On Rent Pune for Comfortable Travel",
        "WhyChoosedescription": "Bus On Rent Pune is perfect for local sightseeing, family outings, group trips, corporate travel, and leisure journeys, ensuring a smooth and hassle-free ride."
    },
    {
        "WhyChooseheading": "Spacious and Modern Urbania Buses",
        "WhyChoosedescription": "Our buses on rent in Pune are fully equipped with air-conditioning, comfortable reclining seats, ample legroom, and sufficient luggage space for a pleasant journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "All drivers are trained, licensed, and experienced in handling Pune city routes and nearby destinations, ensuring safe and stress-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Bus On Rent Pune offers competitive pricing with no hidden charges, making group and tourist travel economical."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Travel Packages",
        "WhyChoosedescription": "Available for local tours, corporate trips, multi-day journeys, family outings, and customized travel plans as per your requirements."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All buses are regularly cleaned, sanitized, and well-maintained to ensure passenger comfort and hygiene."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Bus On Rent Pune service guarantees on-time pickups, dependable service, and a smooth travel experience."
    }
]
}
const faqData = [
    {
        question: 'Can Bus On Rent Pune be booked for local and outstation travel?',
        answer: 'Yes, it can be booked for local sightseeing, corporate trips, family outings, and short-distance outstation travel.'
    },
    {
        question: 'How can I book Bus On Rent Pune?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for quick and convenient reservations.'
    },
    {
        question: 'Why choose Bus On Rent Pune?',
        answer: 'This service offers comfortable seating, professional drivers, clean vehicles, flexible travel plans, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced with Pune routes?',
        answer: 'Yes, all drivers are licensed, trained, and familiar with Pune city routes and nearby destinations.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off locations are available across Pune and nearby areas.'
    },
    {
        question: 'Is Bus On Rent Pune available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey.'
    },
    {
        question: 'Is this service suitable for families and corporate groups?',
        answer: 'Yes, Bus On Rent Pune is ideal for families, corporate groups, and large travel parties.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil Patil',
        feedback: 'We rented a bus in Pune for a family outing. The journey was very comfortable and the bus was clean and spacious.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Ritu Deshmukh',
        feedback: 'Professional service and experienced driver. Bus On Rent Pune made our group travel smooth and enjoyable.',
        rating: 5
    }
];












































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/bus-on-rent-pune.jpg",
  "description": "Bus On Rent Pune offers AC and Non-AC buses for one-way or round-trip travel, corporate trips, weddings, airport transfers, picnics, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in and around Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/bus-on-rent-pune"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Bus On Rent Pune | AC & Non-AC Bus Hire, Corporate & Group Travel 
  </title>

  <meta
    name="description"
    content="Book Bus On Rent Pune for one-way or round-trip travel, corporate trips, weddings, airport transfers, picnics, and group travel. AC and Non-AC chauffeur-driven buses provide safe, comfortable, and convenient transportation in and around Pune."
  />

  <meta
    name="keywords"
    content="Bus on Rent Pune, Bus Hire Pune, AC Bus Rental Pune, Non AC Bus Hire Pune, Corporate Bus Hire Pune, Bus for Wedding Pune, Bus for Outstation Pune, Bus Airport Transfer Pune, Luxury Bus Hire Pune, Affordable Bus Rental Pune, Chauffeur Driven Bus Pune, Bus for Group Travel Pune, Best Bus Rental Pune, Bus for Picnic Pune, Reliable Bus Service Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/91.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busonrentinpune;